import notHandledHere from './notHandledHere';
import { database } from 'lib_ui-services';

export default {
    verb: 'doingRemove',
    excludedNamespaceRelations: notHandledHere.filter(f => f.namespace !== 'file'),
    description: 'Remove the requested record from the database',
    //this is the actual logic:
    logic: doingRemove
};

/**
 * @typedef {import("rulesengine.io").LoggingProvider} LoggingProvider
 * @typedef {import("rulesengine.io").Context} Context
 */

/**
 * @typedef {{trueDelete?: boolean, skipConfirm?: boolean, id:string, meta:object}} RemovePayload
 *
 * @param {{
 *   data: RemovePayload;
 *   prerequisiteResults: object[];
 *   context: Context;
 *   dispatch: (data:object,context:Context,awaitResult?:boolean)=>Promise<void|any>
 *   log: LoggingProvider
 * }} parameters
 * @returns {Promise}
 */
async function doingRemove({ data, context }) {
    const db = database.get();
    const result = await db.remove(data, context);
    return { ...data, result };
}
